<template>
	<router-view
		:user='user'
		@openModal="openModal"
	/>
</template>

<script>

export default {
	name: 'Main',

	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		}
	},

	methods: {
		openModal (target) {
			this.$emit('openModal', target)
		}
	}
}
</script>